import OverlapItem from "../OverlapItem/OverlapItem"
import Show from "../Show/Show"

interface OverlapsProps {
    overlaps?: string | null
}

export default function Overlaps(props: OverlapsProps) {

    const { overlaps } = props

    const tasks = overlaps?.split(",").map(overlap => overlap.trim()).sort() || []

    return (
        <div>
            <Show on={tasks?.length > 0}>
                <p><b>Sobreposições ({tasks?.length})</b></p>
                {tasks.map(task => <OverlapItem taskId={task} />)}
            </Show>
            <Show on={tasks?.length === 0}>
                <p><b>Não existem sobreposições</b></p>
            </Show>
        </div>
    )
}
